module.exports = __webpack_public_path__ + "static/media/ai-ad-elsayedMOBILE.ef41502a.mp4";